import { List } from '../List'
import { CommonWork } from '../CommonWork'
import { ContestBody } from './ContestBody'

export class ContestParent extends List {
  constructor(obj) {
    super(Contest, obj)
  }
}

export class Contest {
  constructor(obj) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.contestBody = new ContestBody(obj?.contestBody || null)
    this.executionFromDate = obj?.executionFromDate || null
    this.executionToDate = obj?.executionToDate || null
    this.commitmentDate = obj?.commitmentDate || null
    this.contestResult = obj?.contestResult || null
    this.link = obj?.link || null
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      contestBody: this.contestBody.getForAPI(),
      executionFromDate: this.executionFromDate,
      executionToDate: this.executionToDate,
      commitmentDate: this.commitmentDate,
      link: this.link,
      contestResult: this.contestResult
    }
  }
}
